import React from 'react'
import './AuthPages.css'

interface SessionExpiredPageProps {
  onSignInAgain?: () => void
}

const SessionExpiredPage: React.FC<SessionExpiredPageProps> = ({ onSignInAgain }) => {
  const handleSignInAgain = () => {
    if (onSignInAgain) {
      onSignInAgain()
    } else {
      window.location.href = '/'
    }
  }

  return (
    <div className="auth-page auth-page--expired">
      <div className="auth-page__bg" />
      <div className="auth-card auth-card--expired">
        <div className="auth-card__icon auth-card__icon--expired" aria-hidden>
          <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10" />
            <polyline points="12 6 12 12 16 14" />
          </svg>
        </div>
        <h1 className="auth-card__title">Session expired</h1>
        <p className="auth-card__message">
          Your session or access has expired. Please sign in again to continue.
        </p>
        <button type="button" className="auth-card__btn auth-card__btn--primary" onClick={handleSignInAgain}>
          Sign in again
        </button>
      </div>
    </div>
  )
}

export default SessionExpiredPage
